module.exports = __webpack_public_path__ + "img/allow_icon.5693c634.jpg";